<template>
    <div>
        <Card>        
            <p slot="title">
                <Affix >
                    <div style="background:#FFFFFF;width:250px;">
                            <i-switch
                                v-model="checkAll"
                                size="small">
                            </i-switch>
                            Partai {{ containerData.containerCode }} - {{ containerData.loadDate | dateFormatted}}
                    </div>        
                </Affix >
            </p>
            

            <div v-for="invoice in invoicesFormatted">

              <cInvoiceReceiveRow
                :invoice="invoice"
                :checkAll="checkAll"
                @setInvoiceChanged="setInvoiceChanged"
                ></cInvoiceReceiveRow>                
                <br/>
                
            </div>
        </Card>
    </div>
</template>

<script>
import cInvoiceReceiveRow from '@/components/invoice/cInvoiceReceiveRow'
const numeral = require('numeral');
import moment from 'moment'


export default {
    components : {cInvoiceReceiveRow},    
    props: {
        container : Object
    },
    data: () => ({
        notes : [],
        containerData : Object,
        checkAll : false,
        invoicesFormatted : [],
        invoiceFinished : []
    }),  
    methods: {
        formattingContainer: function()
        {
            let invoicesFormatted = [];
            this.containerData =
            {
                containerCode  : this.container.invoices[0].packaging_list.container_loading.containercode,
                loadDate  : this.container.invoices[0].packaging_list.container_loading.loaddate,
            } 

            _.forEach(this.container.invoices, function(value) {
                let invoice = {
                    invoiceid : value.invoiceid,
                    totalctns : value.totalctns + ' - ' + numeral(value.totalvolume).value(),
                    markingheadercode : value.packaging_list.marking_minified.markingheadercode,
                    notes : '',
                    isReceived : false,
                    invoiceReceiveDo : value.invoice_receive_do,
                }

                invoicesFormatted.push(invoice);
            });
            invoicesFormatted = _.sortBy(invoicesFormatted, ['markingheadercode']);
            this.invoicesFormatted = invoicesFormatted;
        },
        setInvoiceChanged: function (invoiceChanged){
            this.$emit('setInvoiceChanged', invoiceChanged)
        }                
    },    
    filters: {
        // showDateFormatted : function(stringToFormat){
        //     let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
        //     return moment(dateToFormat).format("DD MMM YYYY")
        // }    
    } ,    
    created() {
        this.formattingContainer();
    }      
}

</script>
<style>
</style>


// WEBPACK FOOTER //
// cInvoiceReceive.vue?59197196